
export default {
  data() {
    return {
      inView: false,
      faq: [0],
      page: null,
      pages: null,
      pageData: null,
      options: [
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
        {
          name: "description",
          label: "Opis",
          type: "tipTap",
        },
        {
          name: "image",
          label: "Image",
          type: "image",
        },
        {
          name: "link",
          label: "Poveznica",
          type: "link",
        },
      ],
    };
  },
  mounted() {
    this.getPages();
    // this.$watch(
    //   () => {
    //     return this.$refs.faqList.items;
    //   },
    //   (val) => {
    //     if (this.page == null) {
    //       this.openPage(this.$refs.faqList.items[0].slug);
    //     }
    //   }
    // );
  },
  methods: {
    async getPages() {
      this.pages = await this.$getCustomPost("", ["faq"]);
      if (this.pages.length) {
        this.openPage(this.pages[0].slug);
      }
    },
    async openPage(page) {
      this.page = page;
      this.pageData = await this.$getPageData(page);
      this.faq = [0];
    },
    openAnswer(index) {
      if (this.faq.includes(index)) {
        const faqIndex = this.faq.indexOf(index);
        this.faq.splice(faqIndex, 1);
      } else {
        this.faq.push(index);
      }
    },
  },
};
